const links = [
  {
    label: 'Wordpress blog',
    href: 'https://kabiri.org',
    description: 'Archive and older posts'
  },
  {
    label: "Your IP",
    href: "/apps/ip",
    description: "Show your public IP and browser engine details.",
  },
  {
    label: 'Buy me a coffee',
    href: 'https://ko-fi.com/superus8r',
    description: 'Support my work'
  }
];

export default links;
